var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useToast } from '@/hoc';
import useApi from '@/hoc/hooks/useApi';
import { cn } from '@/utils';
import React, { useEffect, useState } from 'react';
import { PlusIcon } from '../icons/plus-icon';
import ManageCustomization from '../manage-customization';
import StatusList from '../status-list/index';
import { Button, Text } from '../ui';
var API_URL = '/stage';
var StatusContainer = function () {
    var _a = useApi(API_URL), data = _a.data, loading = _a.loading, error = _a.error, fetchData = _a.fetchData, createItem = _a.createItem, deleteItem = _a.deleteItem, updateItem = _a.updateItem;
    // States
    var _b = useState([]), statuses = _b[0], setStatuses = _b[1];
    var _c = useState(false), isEditing = _c[0], setIsEditing = _c[1];
    var _d = useState([]), originalStatuses = _d[0], setOriginalStatuses = _d[1]; // Store original
    var _e = useState(false), showManageCustomizationComponent = _e[0], setShowManageCustomizationComponent = _e[1];
    var _f = useState(0), maxOrder = _f[0], setMaxOrder = _f[1]; // Store maxOrder in state
    // Toast
    var showToast = useToast().showToast;
    useEffect(function () {
        fetchData();
    }, [fetchData]);
    var handleDeleteItem = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!(data === null || data === void 0 ? void 0 : data.some(function (item) { var _a; return item._id === id || ((_a = item.children) === null || _a === void 0 ? void 0 : _a.some(function (child) { return child._id === id; })); }))) {
                return [2 /*return*/, {
                        status: 'success',
                    }];
            }
            return [2 /*return*/, deleteItem(id)];
        });
    }); };
    // Function to get max order value
    var calculateMaxOrder = function (stages) {
        var getAllOrders = function (stages) {
            return stages.flatMap(function (stage) { return __spreadArray([
                stage.order
            ], (stage.subStages && stage.subStages.length > 0 ? getAllOrders(stage.subStages) : []), true); });
        };
        var allOrders = getAllOrders(stages);
        return allOrders.length > 0 ? Math.max.apply(Math, allOrders) : 0;
    };
    useEffect(function () {
        if (data) {
            var formattedData = data.map(function (item) {
                var _a;
                return ({
                    id: item._id, // Convert API `_id` to `id`
                    name: item.name,
                    order: item.order,
                    isDefault: item.isDefault,
                    subStages: ((_a = item.children) === null || _a === void 0 ? void 0 : _a.map(function (child) { return ({
                        parentId: child === null || child === void 0 ? void 0 : child.parentId,
                        sub_id: child === null || child === void 0 ? void 0 : child._id,
                        name: child.name,
                        isDefault: child.isDefault,
                        order: child.order,
                    }); })) || [],
                });
            });
            setStatuses(formattedData);
            setOriginalStatuses(formattedData);
            setMaxOrder(calculateMaxOrder(formattedData)); // Update maxOrder state
        }
    }, [data]);
    // Handle adding a new status
    // const handleAddStatus = () => {
    //   setStatuses((prev) => [
    //     ...prev,
    //     { id: Date.now().toString(), name: '', order: maxOrder + 1, subStages: [] },
    //   ]);
    // };
    var handleAddStatus = function () {
        var getAllOrders = function (stages) {
            return stages.flatMap(function (stage) { return __spreadArray([
                stage.order
            ], (stage.subStages && stage.subStages.length > 0 ? getAllOrders(stage.subStages) : []), true); });
        };
        var allOrders = getAllOrders(statuses);
        var dynamicMaxOrder = allOrders.length > 0 ? Math.max.apply(Math, allOrders) : 0;
        setStatuses(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            {
                id: Date.now().toString(),
                name: '',
                order: dynamicMaxOrder + 1,
                subStages: [],
            },
        ], false); });
    };
    var handleSaveStatuses = function () { return __awaiter(void 0, void 0, void 0, function () {
        var hasEmptyNames, newStatuses, newSubStages, updatedStatuses, updatedSubStages, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 10, , 11]);
                    hasEmptyNames = statuses.some(function (status) { return !status.name.trim() || status.subStages.some(function (sub) { return !sub.name.trim(); }); });
                    if (hasEmptyNames) {
                        showToast({ message: 'All items must have names', status: 'error' });
                        return [2 /*return*/];
                    }
                    newStatuses = statuses
                        .filter(function (status) { return !originalStatuses.some(function (orig) { return orig.id === status.id; }); })
                        .map(function (_a) {
                        var name = _a.name, order = _a.order;
                        return ({ name: name, order: order, isDefault: order === 1 });
                    });
                    newSubStages = statuses.flatMap(function (status) {
                        return status.subStages
                            .filter(function (sub) {
                            var _a;
                            return !((_a = originalStatuses
                                .find(function (orig) { return orig.id === status.id; })) === null || _a === void 0 ? void 0 : _a.subStages.some(function (origSub) { return origSub.sub_id === sub.sub_id; }));
                        })
                            .map(function (_a) {
                            var name = _a.name, order = _a.order, parentId = _a.parentId;
                            return ({ name: name, order: order, parentId: parentId });
                        });
                    });
                    if (!(newStatuses.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, createItem(newStatuses)];
                case 1:
                    _a.sent();
                    showToast({ message: 'Statuses saved successfully!', status: 'success' });
                    fetchData(); // Refresh API data
                    _a.label = 2;
                case 2:
                    if (!(newSubStages.length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, createItem(newSubStages)];
                case 3:
                    _a.sent();
                    showToast({ message: 'Statuses saved successfully!', status: 'success' });
                    fetchData(); // Refresh API data
                    _a.label = 4;
                case 4:
                    updatedStatuses = statuses
                        .filter(function (status) {
                        var original = originalStatuses.find(function (orig) { return orig.id === status.id; });
                        return original && (original.name !== status.name || original.order !== status.order);
                    })
                        .map(function (_a) {
                        var id = _a.id, name = _a.name, order = _a.order;
                        return ({
                            _id: id, // Ensure API uses `_id`
                            name: name,
                            order: order,
                        });
                    });
                    updatedSubStages = statuses.flatMap(function (status) {
                        return status.subStages
                            .filter(function (sub) {
                            var originalStatus = originalStatuses.find(function (orig) { return orig.id === status.id; });
                            var originalSubStage = originalStatus === null || originalStatus === void 0 ? void 0 : originalStatus.subStages.find(function (origSub) { return origSub.sub_id === sub.sub_id; });
                            return (originalSubStage &&
                                (originalSubStage.name !== sub.name || originalSubStage.order !== sub.order));
                        })
                            .map(function (_a) {
                            var sub_id = _a.sub_id, name = _a.name, order = _a.order, parentId = _a.parentId;
                            return ({
                                _id: sub_id, // API uses `_id`
                                name: name,
                                order: order,
                                parentId: parentId,
                            });
                        });
                    });
                    if (!(updatedStatuses.length > 0)) return [3 /*break*/, 6];
                    return [4 /*yield*/, updateItem(updatedStatuses, fetchData)];
                case 5:
                    _a.sent();
                    showToast({ message: 'Statuses updated successfully!', status: 'success' });
                    _a.label = 6;
                case 6:
                    if (!(updatedSubStages.length > 0)) return [3 /*break*/, 8];
                    return [4 /*yield*/, updateItem(updatedSubStages, fetchData)];
                case 7:
                    _a.sent();
                    showToast({ message: 'Sub-stages updated successfully!', status: 'success' });
                    _a.label = 8;
                case 8: 
                // Refresh data and sync UI
                return [4 /*yield*/, fetchData()];
                case 9:
                    // Refresh data and sync UI
                    _a.sent();
                    setOriginalStatuses(__spreadArray([], statuses, true)); // Sync UI
                    setIsEditing(false);
                    return [3 /*break*/, 11];
                case 10:
                    err_1 = _a.sent();
                    showToast({ message: 'Failed to update statuses', status: 'error' });
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: 'rounded-[10px] bg-white', children: [!showManageCustomizationComponent && (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'flex items-center justify-between p-[10px]', children: [_jsxs("div", { children: [_jsx(Text, { variant: 'heading', children: "Candidate Status Management" }), _jsx(Text, { variant: 'label', children: "Candidate Status Management so that I can customize candidate statuses conveniently." })] }), _jsxs("div", { className: cn('grid gap-2', {
                                    'grid-cols-1': isEditing,
                                    'grid-cols-2': !isEditing,
                                }), children: [!isEditing && (_jsxs(_Fragment, { children: [_jsx(Button, { variant: 'secondaryOutline', className: 'rounded-md', onClick: function () { return setShowManageCustomizationComponent(true); }, children: "Manage Customization" }), _jsx(Button, { variant: 'primary', className: 'rounded-md', onClick: function () {
                                                    setOriginalStatuses(__spreadArray([], statuses, true)); // Save original data before editing
                                                    setIsEditing(true);
                                                }, children: "Manage Status" })] })), isEditing && (_jsx(Button, { variant: 'primary', onClick: handleAddStatus, children: _jsxs("span", { className: 'flex justify-center items-center gap-2', children: ["Add New Status ", _jsx(PlusIcon, {})] }) }))] })] }), loading ? (_jsxs("div", { className: 'space-y-4 px-[20px] pb-[20px]', children: [_jsx("div", { className: 'h-5 w-full bg-gray-200 animate-pulse rounded' }), _jsx("div", { className: 'h-5 w-full bg-gray-200 animate-pulse rounded' }), _jsx("div", { className: 'h-5 w-full bg-gray-200 animate-pulse rounded' }), _jsx("div", { className: 'h-5 w-full bg-gray-200 animate-pulse rounded' })] })) : (_jsxs(_Fragment, { children: [_jsx(StatusList, { statuses: statuses, setStatuses: setStatuses, isEditing: isEditing, deleteItem: handleDeleteItem, maxOrder: maxOrder }), isEditing && (_jsxs("div", { className: 'flex justify-end space-x-2 px-4 py-2', children: [_jsx(Button, { variant: 'secondary', onClick: function () {
                                            setStatuses(__spreadArray([], originalStatuses, true)); // Restore original state
                                            setIsEditing(false);
                                        }, children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: function () {
                                            handleSaveStatuses();
                                        }, children: "Save" })] }))] }))] })), showManageCustomizationComponent && (_jsx(ManageCustomization, { onBack: function () { return setShowManageCustomizationComponent(false); } }))] }));
};
export default StatusContainer;
